import { Component, OnInit } from '@angular/core';
import { ManageType } from 'src/app/decorators/type-manager-decorator';

@ManageType('LaboPanelComponent')
@Component({
  selector: 'app-labo-panel',
  templateUrl: './labo-panel.component.html',
  styleUrls: ['./labo-panel.component.scss']
})
export class LaboPanelComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  newLabo(): void {

  }

}
